module.exports = __webpack_public_path__ + "img/457.d9e95d52.jpg";